module.exports = __webpack_public_path__ + "static/media/siriLogo.31c16524.png";